import { styled } from 'styled-components';

interface EmailStyleEmailInputProps {
  error?: string;
}

interface StyleConnectArrowIconProps {
  disabled?: boolean;
  $canClick: boolean;
  $isError?: boolean;
}

export const EmailLoginContainer = styled.div`
  width: 100%;
`;

export const StyleEmailInputWrapper = styled.div`
  position: relative;
`;

export const StyleConnectArrowIcon = styled.div<StyleConnectArrowIconProps>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
  cursor: pointer;
  border-radius: 100%;

  ${({ $canClick, $isError }) => {
    if ($canClick) {
      return `
      .icon-0x7ff{     
        path {
          fill: #fff !important;
        }
          circle {
            fill: ${$isError ? 'var(--pcm-error-color) !important' : 'var(--pcm-accent-color) !important'}  ;
          }
      }
   
      `;
    } else {
      return `
        cursor: default;
       .icon-0x7ff{
        path {
          fill: #fff !important;
        }
          circle {
          fill: var(--pcm-body-background-secondary) !important;
          }}
      `;
    }
  }}

  ${({ disabled, $canClick }) =>
    disabled &&
    $canClick &&
    `
    cursor: default;
    opacity: 0.5;
  `}
`;

export const StyleEmailInput = styled.input<EmailStyleEmailInputProps>`
  border-radius: var(--pcm-rounded-lg);
  height: 47px;
  padding: 0 12px;
  width: 100%;
  font-size: 15px;
  font-weight: normal;
  background-color: ${({ error }) => (error ? 'var(--pcm-error-background)' : 'var(--pcm-body-background-tertiary)')};
  color: ${({ error }) => (error ? 'var(--pcm-error-color)' : 'var(--pcm-body-color)')};
  border: none;
  &::placeholder {
    color: var(--pcm-body-color-tertiary);
  }
`;

export const StyleInputError = styled.div`
  color: var(--pcm-error-color);
  font-size: 12px;
  display: flex;
  padding-left: 14px;
  margin-top: 14px;
  align-items: center;
  line-height: 16px;
  div:nth-child(1) {
    min-width: 20px;
  }
`;
